import type { Client } from "@medusajs/js-sdk";
import { Store as MedusaStore } from "@medusajs/js-sdk";
import { Cart } from "./cart";
import { Category } from "./category";
import { Concierge } from "./concierge";
import { Product } from "./product";
import { Seller } from "./seller";
import { SellerCart } from "./seller-cart";
import { SellerOffer } from "./seller-offer";
import { Customer } from "./customer";
import { Favorites } from "./favorites";
import { OrderSet } from "./order-set";
import { OrderHistory } from "./order-history";
import { Reorder } from "./reorder";
import { SavedList } from "./saved-list";
import { StockTracking } from "./stock-tracking";
import { SupplierCatalog } from "./supplier-catalog";
import { SupplierMatch } from "./supplier-match";
import { VoiceOrder } from "./voice-order";

export class Store extends MedusaStore {
  /** Multi-seller cart methods (one cart per seller architecture) */
  /**
   * @deprecated use sdk.store.sellerCart instead
   */
  public cart: Cart;
  public category: Category;
  public concierge: Concierge;
  public customer: Customer;
  public favorites: Favorites;
  public orderHistory: OrderHistory;
  public orderSet: OrderSet;
  public product: Product;
  public reorder: Reorder;
  public savedList: SavedList;
  public stockTracking: StockTracking;
  public seller: Seller;
  public sellerCart: SellerCart;
  public sellerOffer: SellerOffer;
  public supplierCatalog: SupplierCatalog;
  public supplierMatch: SupplierMatch;
  public voiceOrder: VoiceOrder;

  constructor(client: Client) {
    super(client);
    this.cart = new Cart(client);
    this.category = new Category(client);
    this.concierge = new Concierge(client);
    this.customer = new Customer(client);
    this.favorites = new Favorites(client);
    this.orderHistory = new OrderHistory(client);
    this.orderSet = new OrderSet(client);
    this.product = new Product(client);
    this.reorder = new Reorder(client);
    this.savedList = new SavedList(client);
    this.stockTracking = new StockTracking(client);
    this.seller = new Seller(client);
    this.sellerCart = new SellerCart(client);
    this.sellerOffer = new SellerOffer(client);
    this.supplierCatalog = new SupplierCatalog(client);
    this.supplierMatch = new SupplierMatch(client);
    this.voiceOrder = new VoiceOrder(client);
  }
}
